export default __webpack_public_path__ + "static/media/ic-calendar.852a4c43.svg";